import React from "react";
import { Navigate } from "react-router-dom";

/** Legacy `/admin/dashboard` URL; redirects for bookmarks. */
export const AdminDashboard: React.FC = () => (
  <Navigate to="/admin/daily-cash" replace />
);
